import ComplianceStageBadge from './ComplianceStageBadge'
import RiskScoreBadge from './RiskScoreBadge'
import CddTierBadge from './CddTierBadge'

/**
 * Standard three-badge patron context strip: Stage · Patron risk · CDD.
 * Pass preloaded fields from overview/case APIs to avoid extra requests.
 */
export default function PatronComplianceStrip({
  complianceStage,
  riskScore,
  riskLevel,
  cddTier,
  size = 'default',
  className = '',
  dark = false,
}) {
  const gap = size === 'compact' ? 'gap-1.5' : 'gap-2'
  const wrap = dark
    ? `${gap} [&_span]:ring-1 [&_span]:ring-white/10`
    : gap

  return (
    <div className={`flex flex-wrap items-center ${wrap} ${className}`}>
      <ComplianceStageBadge stage={complianceStage || 'fresh'} size={size} />
      <RiskScoreBadge score={riskScore} level={riskLevel} size={size} />
      <CddTierBadge tier={cddTier} size={size} />
    </div>
  )
}
